export const pluralise = (count, singular, plural) => {
  return count === 1 ? singular : plural;
};

export const getCurrentPath = () => {
  try {
    const currentUrl = new URL(window.location.href);

    return currentUrl.pathname;
  } catch {
    return null;
  }
};

/**
 * Safely check media query, using Modernizr if available, otherwise window.matchMedia
 * @param {string} query - Media query string (e.g., '(max-width: 768px)')
 * @returns {boolean} - Whether the media query matches
 */
export const matchMediaQuery = (query) => {
  if (typeof window === 'undefined') {
    return false;
  }

  // Use Modernizr if available (legacy support)
  if (typeof Modernizr !== 'undefined' && Modernizr.mq) {
    return Modernizr.mq(query);
  }

  // Fallback to native matchMedia
  if (window.matchMedia) {
    return window.matchMedia(query).matches;
  }

  // Final fallback
  return false;
};

/**
 * Safely check if fullscreen API is supported
 * @returns {boolean} - Whether fullscreen is supported
 */
export const isFullscreenSupported = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  // Use Modernizr if available (legacy support)
  if (typeof Modernizr !== 'undefined' && 'fullscreen' in Modernizr) {
    return Modernizr.fullscreen === true;
  }

  // Fallback to native fullscreen API detection
  return !!(
    document.fullscreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled
  );
};

// Remove Modernizr no-js fallback
if (typeof document !== 'undefined' && document.documentElement) {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
}
